exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lookup-popup-container {\n    background: #F0F0F0;\n}\n.lookup-popup-container .search-filter-block {\n    padding-left: 20px;\n    padding-right: 20px;\n}\n.lookup-popup-container .lookup-popup-divider {\n    margin: 0px;\n}\n.lookup-popup-container .search-results-title {\n    /* LFWM-2625 - lookup alignment changes */\n    padding-left: 24px;\n    color: #12408B;\n    font-weight: 400;\n    font-size: 16px;\n}\n\n.lookup-popup-container .search-results-block {\n    padding-top: 10px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/lookup/serial-number-popup/serial-number-popup.component.css
// module id = ../../../../../src/app/shared/lookup/serial-number-popup/serial-number-popup.component.css
// module chunks = main